import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeReviewsGoToAppModal } from 'shared/actions/reviewsGoToAppModal';
import { ReviewsGoToAppModal } from 'shared/components/ReviewsGoToAppModal';
import { useDailyRentReviews } from 'shared/hooks/useReviewsMiniWidget';
import { selectReviewGoToAppModalOpen } from 'shared/selectors/reviewGoToAppModal';

export function ReviewsGoToAppModalContainer() {
  const dispatch = useDispatch();
  const isOpen = useSelector(selectReviewGoToAppModalOpen);
  const { isReviewsEnabled } = useDailyRentReviews();

  const onClose = React.useCallback(() => {
    dispatch(closeReviewsGoToAppModal());
  }, [dispatch]);

  if (!isReviewsEnabled) {
    return null;
  }

  return <ReviewsGoToAppModal open={isOpen} onClose={onClose} onConfirm={onClose} />;
}
